export default __webpack_public_path__ + "static/media/Armbands of the Ichorous.051a49ce.jpg";